<!-- components/seminar/SeminarDifference.vue -->
<template>
    <section class="icon-difference py-3 text-center" style="background-color: #f2f7f3;">
      <h4 class="mb-2 mobile-title">Faites le choix d’un séminaire</h4>
      <h1 class="mb-3 mobile-sub">qui fait la différence</h1>
      <div class="icon-wrapper">
        <div class="icon-grid">
          <div class="icon-card" v-for="(icon, index) in icons" :key="index" :style="{ marginTop: index === 0 ? '1.5vh' : '' }">
            <img :src="icon.image" :alt="icon.alt" />
            <p class="raleway-bold-16" style="font-family: 'Raleway'; font-weight: 700; font-size: 16px;">{{ icon.label }}</p>
          </div>
        </div>
      </div>
    </section>
  </template>
  
  <script>
  export default {
    name: "SeminarDifference",
    props: {
      icons: {
        type: Array,
        required: true
      }
    }
  };
  </script>
  
  <style scoped>

.icon-difference {
  font-family: 'Raleway', sans-serif;
}

.icon-difference h1,
.icon-difference h2,
.icon-difference h3,
.icon-difference h4 {
  font-family: 'Merriweather', serif;
}
.raleway-reg-p15 {
  font-family: 'Raleway', sans-serif;
  font-size: 15px;
  font-weight: 400;
}
  .icon-grid {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 3rem;
    padding: 2rem 1rem;
  }
  
  .icon-card {
    width: 150px;
    text-align: center;
  }
  
  .icon-card img {
    width: 45px;
    margin-bottom: 0.5rem;
  }
  
  .icon-card p {
    font-size: 0.85rem;
    font-weight: 400;
    text-transform: uppercase;
  }
  
  .icon-wrapper {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  
  @media (max-width: 768px) {
    .icon-grid {
      flex-wrap: nowrap;
      gap: 2rem;
      padding: 1rem;
      min-width: max-content;
    }
  
    .icon-card {
      flex: 0 0 auto;
      width: 160px;
    }
  }
  @media (max-width: 485px) {
	.mobile-title{
		font: normal normal normal 18px/40px Merriweather;
	}
	.mobile-sub{
		font: normal normal normal 32px/40px Merriweather;
	}
}
  </style>
  